<script>
  let name = '';
  let phoneNumber = '';
  let email = '';
  let message = '';
  let submissionStatus = ''; // Stati: '', 'success', 'error'
  let isSubmitting = false;

  async function handleSubmit(event) {
    const formData = new FormData(event.target);
    submissionStatus = '';
    isSubmitting = true;

    try {
      const response = await fetch(event.target.action || "/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });

      if (response.ok) {
        submissionStatus = 'success';
        name = '';
        phoneNumber = '';
        email = '';
        message = '';
      } else {
        const errorText = await response.text();
        console.error("Errore nell'invio del form a Netlify:", response.status, response.statusText, errorText);
        submissionStatus = 'error';
      }
    } catch (error) {
      console.error("Errore di rete o JavaScript durante l'invio del form:", error);
      submissionStatus = 'error';
    } finally {
      isSubmitting = false;
    }
  }
</script>

<svelte:head>
  <title>I miei contatti - Dott.ssa Eleonora Ceroni Psicologa Faenza</title>
  <meta name="description" content="Questi sono i miei contatti, se preferisci puoi inviare un form anonimo per poter concordare un appuntamento conoscitivo a Faenza." />
</svelte:head>

<section id="contatti" class="contact">

  <h2>CONTATTI</h2>
  <p class="intro">Ricevo su appuntamento sia in studio che online.<br />
Per informazioni o prenotazione di un appuntamento puoi contattarmi tramite telefono, WhatsApp, e-mail o compilando il form qui sotto.
</p>
  <div class="contact-content">
    <div class="contact-info">
      <h3>Informazioni di contatto</h3>
      <a href="https://wa.me/3534687621" target="_blank" class="contact-link whatsapp-link">
        <img src="https://cdnjs.cloudflare.com/ajax/libs/simple-icons/3.0.1/whatsapp.svg" alt="WhatsApp" class="contact-icon" /> 353 4687621
      </a>
      <p>
        <a href="mailto:eleonoraceroni.psi@gmail.com" class="contact-link email-link">
          📧 eleonoraceroni.psi@gmail.com
        </a>
      </p>
      <p>
        <a href="https://www.google.com/maps/search/?api=1&query=Via+Marescalchi++30,+48018+Faenza" target="_blank" class="contact-link address-link">
          📍 Via Marescalchi 30, Faenza
        </a>
      </p>
    </div>

    <form
      name="contact"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      action={typeof window !== 'undefined' ? window.location.pathname : '/'}
      on:submit|preventDefault={handleSubmit}
    >
      <input type="hidden" name="form-name" value="contact" />
      <p style="position: absolute; left: -5000px; top: -5000px;">
        <label>
          Non compilare se sei umano: <input name="bot-field" />
        </label>
      </p>

      <h3>Form di contatto</h3>

      <input
        type="text"
        bind:value={name}
        name="name"
        placeholder="Nome"
        required
        disabled={isSubmitting}
      />

      <input
        type="email"
        bind:value={email}
        name="email"
        placeholder="Email"
        required
        disabled={isSubmitting}
      />

      <input
        type="tel"
        bind:value={phoneNumber}
        name="phone_number"
        placeholder="Numero di cellulare"
        required
        disabled={isSubmitting}
        pattern="[0-9\s\-\+\(\)]*"
        title="Inserisci un numero di telefono valido."
      />

      <textarea
        bind:value={message}
        name="message"
        placeholder="Messaggio"
        required
        disabled={isSubmitting}
      ></textarea>

      <div class="button-container">
        <button type="submit" disabled={isSubmitting}>
          {#if isSubmitting}Invio in corso...{:else}Invio{/if}
        </button>
      </div>

      {#if submissionStatus === 'success'}
        <p class="form-feedback success">Grazie! Il tuo messaggio è stato inviato con successo.</p>
      {:else if submissionStatus === 'error'}
        <p class="form-feedback error">Oops! C'è stato un errore durante l'invio. Riprova più tardi.</p>
      {/if}
    </form>
  </div>
</section>

<style>
  .contact {
    padding: 1rem 2rem;
    background-color: rgba(231,207,194,0.4);
    margin: 2rem 0;
    border-radius: 10px;
  }
  h2 {
    text-align: center;
    margin-bottom: 1rem;
    color: var(--accent-color);
    font-size: 2.5rem;
  }
  .intro {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    color: var(--text-color);
    font-size: 1.1rem;
    max-width: 700px;
    line-height: 1.6;
  }
  h3 {
    text-align: left;
    margin-bottom: 2rem;
    color: var(--accent-color);
    font-size: 1.5rem;
  }
  .contact-content {
    display: flex;
    justify-content: space-between;
    max-width: 1000px;
    margin: 0 auto;
  }
  .contact-info, form {
    flex: 1;
    padding: 0 1rem;
  }
  input, textarea {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    font-family: inherit;
    font-size: 1rem;
  }
  textarea {
    height: 150px;
    resize: vertical;
  }
  .button-container {
    text-align: center;
  }
  button {
    background-color: var(--accent-color);
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: 1rem;
    font-weight: bold;
  }
  button:hover:not(:disabled) {
    opacity: 0.9;
  }
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  .contact-link {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    color: var(--text-color);
    margin-top: 1rem;
    transition: color 0.3s ease;
    font-size: 1rem;
  }
  .contact-link:hover {
    color: var(--accent-color);
  }
  .contact-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .form-feedback {
    margin-top: 1em;
    padding: 0.75em;
    border-radius: 4px;
    text-align: center;
    font-size: 0.95rem;
  }
  .form-feedback.success {
    background-color: #e6fffa;
    color: #006400;
    border: 1px solid #b3ffeb;
  }
  .form-feedback.error {
    background-color: #fff0f0;
    color: #a80000;
    border: 1px solid #ffcccc;
  }
  @media (max-width: 768px) {
    .contact-content {
      flex-direction: column;
    }
    .contact-info, form {
      margin-bottom: 2rem;
      width: 100%;
      padding: 0;
    }
    .contact-info {
        text-align: center;
        margin-bottom: 3rem;
    }
    h3 {
        text-align: center;
        font-size: 1.3rem;
    }
    .intro {
        font-size: 1rem;
    }
  }
</style>